import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'asset-upload',
  templateUrl: './asset-upload.component.html',
  styleUrls: ['./asset-upload.component.less']
})

export class AssetUploadComponent implements OnInit {
  @Input() heading: string = '';
  @Input() hideButtons: boolean = false;
  @Output() asset: EventEmitter<string> = new EventEmitter();
  @Output() saveAction: EventEmitter<void> = new EventEmitter();

  uploading: boolean = false;
  assetLoaded: boolean = false;
  progress: number = 0;
  message: string = '';
  file: any;

  constructor(
    private snackBar: MatSnackBar
  ) { }

  @ViewChild('file', { static: false }) fileElement: ElementRef | undefined;

  ngOnInit() {}

  upload(files: any) {
    this.uploading = true;
    if (files.length === 0) {
      this.showMessage(`${""} Asset Load Failed - No file selected!`);
      this.uploading = false;
      (this.fileElement as ElementRef).nativeElement.value = '';
      return;
    }

    if(files[0].type !== 'image/png'){
      this.showMessage(`${""} Asset Load Failed - Only .png permitted!`);
      this.uploading = false;
      (this.fileElement as ElementRef).nativeElement.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const assetData = reader.result?.toString();
      this.asset.emit(assetData);
      this.uploading = false;
    };

    reader.readAsDataURL(files[0]);
    this.assetLoaded = true;
  }

  public triggerFileUpload() {
    if (this.fileElement) {
      this.fileElement.nativeElement.click();
    }
  }

  showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }

  saveClick() {
    this.saveAction.emit();
  }
}
